export default __webpack_public_path__ + "static/media/Ch3d.0730c2aa.gif";